import { makePhoneLink } from "./helpers";

export default function updateUserLocation(id, title, url, lat, lng, phone) {
  // Clean up title string
  title = title.replace("&#038;", "&");
  title = title.replace("<br>", "");

  // Update header "Your Location" link 
  let link = document.querySelector("#your-location"),
    locationBlock = document.querySelector(".site-header__utility__location p"),
    locationBtn = document.querySelector(".site-header__change-location");

  link.innerText = title;
  link.href = url;
  link.dataset.id = id;
  link.dataset.lat = lat;
  link.dataset.lng = lng,
  link.dataset.phone = phone;

  // Then show utility location block if hidden, & update button text
  if( !locationBlock.classList.contains("visible") ) {
    locationBlock.classList.add("visible");
    locationBtn.innerText = "Change My Location";
  }

  // Also update header & footer dynamic phone links, if they exist 
  let headerPhoneLink = document.querySelector(".nav--utility--top .dynamic-phone-link > a");
  let footerPhoneLink = document.querySelector(".nav--footer .dynamic-phone-link > a");
  let newLink = `tel:${makePhoneLink(phone)}`;

  if( headerPhoneLink ) {
    headerPhoneLink.innerText = phone;
    headerPhoneLink.href = newLink;
  }

  if( footerPhoneLink ) {
    footerPhoneLink.href = newLink;
  }
}